export const state = () => ({
	filter_fields: ['keywords', 'category', 'subcategory', 'page', 'sort', 'min_price', 'max_price', 'colour'],
	categories: {}
});

export const mutations = {};